// extracted by mini-css-extract-plugin
export default {"notificationsStroke":"k4iwe","notificationsFill":"gqNaS"};